import { defineComponent, ref, computed, watch, inject } from 'vue';
import { useStore } from '@/plugins/vuex';
import CompanyService from '@/sections/admin/entities/company/company.service';
import { Rates } from '@/shared/model/rate.model';
import SInputNumber from '@/components/stemdo-components/s-input-number/SInputNumber.vue';
import { SeniorityLevel } from '@/shared/model/enumerations/seniority-level.model';
import SPopUp from '@/components/stemdo-components/s-pop-up/SPopUp.vue';
import { useI18N } from '@/plugins/i18n';

export default defineComponent({
  props: {
    isOpen: { type: Boolean, required: true },
    onCloseModal: { type: Function, required: true },
    onShowPopUp: { type: Function, required: false }
  },
  components: {
    SInputNumber,
    SPopUp
  },
  setup(props) {
    const store = useStore();
    const i18n = useI18N();
    const companyService = inject('companyService') as CompanyService;
    const companySelected = computed(() => store.getters['cartStore/companySelected']);

    const ratesForm = ref([
      { seniority: 'JUNIOR', value: 0, seniorityLabel: SeniorityLevel.JUNIOR },
      { seniority: 'MID_SENIOR', value: 0, seniorityLabel: SeniorityLevel.MID_SENIOR },
      { seniority: 'SENIOR', value: 0, seniorityLabel: SeniorityLevel.SENIOR }
    ]);

    const popUpData = ref({
      message: '',
      isOpen: false,
      isValid: true
    });

    watch(
      companySelected,
      val => {
        if (val && val.rates) {
          ratesForm.value = val.rates.map(rate => ({
            seniority: rate.seniority,
            value: rate.value,
            seniorityLabel: SeniorityLevel[rate.seniority as keyof typeof SeniorityLevel]
          }));
        }
      },
      { immediate: true }
    );

    const onSave = async () => {
      if (!companySelected.value) return;
      try {
        await companyService.partialUpdateCompanyRates(companySelected.value.id, Rates.from(ratesForm.value));
        const updatedCompany = await companyService.find(companySelected.value.id);
        store.commit('cartStore/setCompany', updatedCompany);
        props.onCloseModal();
        if (props.onShowPopUp) {
          props.onShowPopUp({
            message: i18n.t('sEditRates.popupSuccess').toString(),
            isOpen: true,
            isValid: true
          });
        }
      } catch (err) {
        if (props.onShowPopUp) {
          props.onShowPopUp({
            message: i18n.t('sEditRates.popupError').toString(),
            isOpen: true,
            isValid: false
          });
        }
      }
    };

    const onRateChange = (newRate: number, idx: number) => {
      ratesForm.value[idx].value = newRate;
    };

    const onCancel = () => {
      props.onCloseModal();
    };

    return {
      companySelected,
      ratesForm,
      popUpData,
      onSave,
      onCancel,
      onRateChange
    };
  }
});
